import { useContext } from 'react'
import { AppContext, AppContextType } from '../AppContext'
import { persistent } from '../services/LocalStorage'
import CrossPlatformDialog from '../dialogs/components/CrossPlatformDialog'
import EnableSystemAccessPage from './EnableSystemAccessPage/EnableSystemAccessPage'

export default function MediaPermissionsChecklistModal() {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType

    const onCloseDialog = () => {
        appDispatch({
            type: 'update_app_state',
            value: { showMediaPermissionsDialog: false },
        })

        persistent.set('donotshow.MediaPermissionsChecklistModal', true)
    }

    return (
        <>
            {appState.appState.showMediaPermissionsDialog && (
                <CrossPlatformDialog
                    frameName="MediaPermissionsChecklistModal"
                    classNameBrowser="md:w-[630px] h-[700px]"
                    onDefaultClose={onCloseDialog}
                    className="px-0"
                >
                    <EnableSystemAccessPage />
                </CrossPlatformDialog>
            )}
        </>
    )
}
